import { Component, ReactNode } from "react";
import { LinkToContactPage, LinkToEduPage, LinkToHomePage, LinkToTipJarPage } from "../../constants/navUrlConstants";
import "./NavBar.css";

interface Props {
  // onNavigate: (tabName: string)
}
interface State {}

class NavBar extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  switchTab = (tabName: string) => {
    window.location.hash = tabName; // not sure if actually navs
  };

  render(): ReactNode {
    return (
      <nav className="nav-bar">
        <ol>
          <li>
            <button onClick={() => this.switchTab(LinkToHomePage)}>curtisvoorhees.com</button>
          </li>
        </ol>
        <label className="hamburger-menu-label" htmlFor="hamburger-menu-checkbox" tabIndex={0}>
          ☰
        </label>
        <input id="hamburger-menu-checkbox" type="checkbox" />
        <ol>
          {/* <li>
            <button onClick={() => this.switchTab(LinkToMusicPage)}>Music</button>
          </li> */}
          <li>
            <button onClick={() => this.switchTab(LinkToContactPage)}>Contact</button>
          </li>
          {/* <li>
            <button onClick={() => this.switchTab(LinkToEduPage)}>Resources</button>
          </li> */}
          <li>
            <button onClick={() => this.switchTab(LinkToTipJarPage)}>Tip Jar</button>
          </li>
        </ol>
      </nav>
    );
  }
}

export default NavBar;
